import { Injectable } from '@angular/core';
import { IndexType } from '@fnModels/algolia/algolia';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';
import * as actions from './actions';

export type CondoCorporationsSearchStateModel = AlgoliaBaseState<unknown>;

@State<CondoCorporationsSearchStateModel>({
	name: 'condoCorporationsSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class CondoCorporationsSearchState extends AlgoliaSearchState<CondoCorporationsSearchStateModel> {
	protected indexName = getIndex(IndexType.CONDO_CORPORATIONS);

	@Selector([CondoCorporationsSearchState])
	static getList(state: CondoCorporationsSearchStateModel): unknown[] {
		return state?.items;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<CondoCorporationsSearchStateModel>,
		{ searchTerm }: actions.Search,
	): Promise<void> {
		await this.algoliaSearchHandler(ctx, searchTerm);
	}
}
